import { render, staticRenderFns } from "./ArtistExternalStatsBadge.vue?vue&type=template&id=23e066b2&scoped=true&"
import script from "./ArtistExternalStatsBadge.vue?vue&type=script&lang=js&"
export * from "./ArtistExternalStatsBadge.vue?vue&type=script&lang=js&"
import style0 from "./ArtistExternalStatsBadge.vue?vue&type=style&index=0&id=23e066b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e066b2",
  null
  
)

export default component.exports